import { controls } from "../controls";


const pmjjby = {
  label: "Prandhan Mantri Jeevan Jyoti Beema Yojna",
  pageLabel: "Prandhan Mantri Jeevan Jyoti Beema Yojna",
  starting: true,
  url: "pmjjby",
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Create",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "From Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "from_date", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "to_date", width: "col-sm-2", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", label: "Number Of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "per_page", placeHolder: "Enter Number Of Records", width: "col-sm-2" }),



  ],
  form: [
    ...controls.displayText({ tab: "create", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: 'create', isReadOnly: 'edit', isRequired: true, defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-5" }),

    ...controls.displayText({ tab: "create", star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({
      tab: "create", isRequired: true, width: "col-sm-2",
      sendToServer: { dataType: 'product', sendData: [{ varname: 'lastAcNo', fixed: true }, { varname: 'branch_guid', value: 'branch_guid' }] },
      //   clearData: ['customer_number', 'account_type', 'mode_of_operation'],
      displayData: { descn: "product_code_display", guid: "product_code_guid", producttype: "product_type", glrefid: "product_code", nominationavailable: 'nominees_button', allowchequqbook: 'chequebook_button', atmallow: 'atm_button', MaxAcNo: "last_ac_no" }
    }),
    ...controls.showData({
      tab: "create",
      data: "product_code_display", width: "col-sm-2"
    }),
    ...controls.displayText({ tab: "create", label: "", width: "col-sm-6" }),

    ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      tab: "create",
      forceRender: true,
      beforeLeave: ["createAcNo"],
      //   onLeave: ["checkPAN", "checkMobile", "checkSMS", "checkAADHAAR", "checkLoans", "checkAcClosed", "checkLienMarking", "checkMinBal", "checkRenewal", "checkPremature"], // {type:'check',value:'pan'},{type:'match',value:12000},
      clearData: ['entered_amount', 'unposted_interest'],
      displayData: {
        producttype_guid: "producttype_guid", descn: "account_number_display", guid: 'account_number_guid', balance: "balance", pendingcharges: 'pending_charges', customer_number: "customer_number", interest_rate: "interest_rate", mobile: "mobile", interest: "interest", minbalance: "min_balance", pan: "pan", total: "total", fd_amount: "fd_amount", aadhar: "aadhaar", mat_amount: "maturity_amount", opendate: "account_opening_date", expdate: "expdate", closedate: "closedate", intdate: "intdate", withdrawable: "withdrawable", product_code: { field: "product_code", skip: true }, RiskCategory: "RiskCategory", custtype: "custtype", kycduedate: "kycduedate", kycdone: "kycdone", cashpaymentday: "cashpaymentday", cashreceiptday: "cashreceiptday", cashpaymentweek: "cashpaymentweek", cashreceiptweek: "cashreceiptweek", qtrreceipts: "qtrreceipts", qtrpayments: "qtrpayments", cashpaymentyear: "cashpaymentyear", account_code: "account_number", cashreceiptyear: "cashreceiptyear", openbyuser: "openbyuser", closing_charges: "entered_charges", branch_guid: "account_branch_guid"
      },

    }),
    ...controls.showData({ tab: "create", data: "account_number_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-6" }),
    ...controls.displayText({ tab: "create", star: true, label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: 'create', width: "col-sm-2", isRequired: true }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "customer_number_display", name: "customer_number_display" }),
    ...controls.displayText({ tab: "create", width: "col-sm-6" }),
    ...controls.displayText({ tab: "create", label: "Gender:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "gender", name: "gender" }),
    ...controls.displayText({ tab: "create", label: "Date Of Birth:", width: "col-sm-2" }),
    ...controls.showData({
      tab: "create", width: "col-sm-2", data: "dob", name: "dob", displaytype: 'date', onRender: [
        // // sum last column of the current table
        { f: 'calculateAge', calcType: 'sum', inputs: { source: 'pageData.dob', field: 'dob' }, resultVar: 'getCalulateage' },
        // // and set it as some other parentState.
        { f: 'setParentState', inputs: { dest: "pageData.age", source: 'allResults', field: 'getCalulateage' }, resultVar: "age" },
      ]
    }),
    ...controls.displayText({ tab: "create", label: "Age:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "age", name: "age" }),

    ...controls.displayText({ tab: "create", label: "Mobile No:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "mobile", name: "home_no" }),


    ...controls.displayText({ tab: "create", label: "Occupation:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "occupation", name: "occupation" }),
    ...controls.displayText({ tab: "create", label: "Balance:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "balance", name: "cintotbal", displaytype: "currency" }),
    ...controls.displayText({ tab: "create", label: "PAN:", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "pan", name: "panid" }),
    ...controls.displayText({ tab: "create", label: "Aadhar UID", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "aadhaar", name: "aadhar_id" }),
    ...controls.displayText({ tab: "create", label: "Pin Code ", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "pin", name: "pin" }),
    ...controls.displayText({ tab: "create", label: "Email ", width: "col-sm-2" }),
    ...controls.Email({ tab: "create", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", label: "Disability Flag", width: "col-sm-2" }),
    ...controls.radio({ tab: "create", width: "col-sm-2", name: "disability_flag", cwidth: "col-sm-4", options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }], }),
    ...controls.displayText({ tab: "create", label: "Disability Details", width: "col-sm-2" }),
    ...controls.text({ tab: "create", width: "col-sm-2", name: "disability_details", placeHolder: "Disability Details" }),
    ...controls.displayText({ tab: "create", label: "Nominee Name", width: "col-sm-2" }),
    ...controls.text({ tab: "create", width: "col-sm-2", name: "nominee_name", placeHolder: "Nominee Name" }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    // ...controls.displayText({tab: "create", label: "Nominee Aadhar", width: "col-sm-2" }),
    // ...controls.aadharNumber({tab: "create", width: "col-sm-2", name: "nominee_aadhar",placeHolder:"Nominee Aadhar" }),
    // ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.displayText({ tab: "create", label: "Nominee Age", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "create", width: "col-sm-2", name: "nominee_age", placeHolder: "Nominee Age" }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.displayText({ tab: "create", label: "Relation Of Nominee", width: "col-sm-2" }),
    ...controls.RelationCode({ tab: "create", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.displayText({ tab: "create", label: "Guardian Name", width: "col-sm-2" }),
    ...controls.text({ tab: "create", width: "col-sm-2", name: "guardian_name", placeHolder: "Guardian Name" }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.magicDateLabel({ tab: "create", star: true, label: "Opening Date", width: "col-sm-2" }),
    ...controls.magicDate({
      tab: "create",
      isRequired: true, dateType: "ontype", default: "sessiondate", name: "opening_date", width: "col-sm-2"
    }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.displayText({ tab: "create", label: "Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "create", width: "col-sm-2", name: "amount", placeHolder: "Amount" }),
    ...controls.checkBox({ tab: "create", default: true, label: "Active", name: "isActive", width: "col-sm-2" }),


  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    displayColumns: [
      {
        Header: "SB A/c No",
        accessor: "account_number",
        width: 150
      },
      {
        Header: "Full Name",
        accessor: "account_number_display_name",
        width: 150
      },
      {
        Header: "Join Date",
        accessor: "joindate"
      },
      {
        Header: "DOB",
        accessor: "dob"
      },
      {
        Header: "Perm Amt",
        accessor: "premamt",
        type: "currency"
      },
      {
        Header: "Modified By",
        accessor: "createdByName"
      },
      {
        Header: "Modified Date",
        accessor: "createddate"

      },
      {
        Header: "Modified Time",
        accessor: "createdtime",
        show: false
      },
      {
        Header: "Active",
        accessor: "isActive",
        type: "tick"
      },

    ]
  }
}
export default pmjjby